import loadOnce from 'load-script'

export function placeAddressIsValid(address: GooglePlace) {
  /*
  const addressFields = ['administrative_area_level_2', 'country', 'locality', 'postal_code', 'route', 'street_number'];
  return addressFields.every(prop => prop in address)
  */
 return true;
}

export const formatCurrency = (value: number, currency = 'EUR', minimumFractionDigits = 2) => {
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency, minimumFractionDigits }).format(value);
};

export function loadPaypalSDK({ clientId, currency, attributionId, clientToken, externalBusinessId }: PaypalData) {
  return new Promise((resolve) => {
    loadOnce(`https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}&intent=capture&disable-funding=mybank,sofort&components=hosted-fields,buttons&merchant-id=${externalBusinessId}`, {
      attrs: {
        'data-partner-attribution-id': attributionId,
        'data-client-token': clientToken
      }
    }, resolve)
  })
}

export function processAlipayCheckout(checkout: AliPayCheckout, checkoudId: number) {
  const formEl = document.createElement('form')
  const parameters: any = checkout.parameters

  //new Alipay responses need just a redirect: parameters are in query string
  if (checkout.method === "GET" && !parameters) {
    window.location.href = checkout.url;
    return;
  }

  for (const key in parameters) {
    const value = parameters[key] as string
    const input = document.createElement('input')
    input.value = value
    input.name = key
    if (key === 'callback') {
      input.value = `${window.location.href}?alipay_checkout=${checkoudId}`
    }
    formEl.appendChild(input)
  }
  document.body.appendChild(formEl)
  formEl.action = checkout.url
  formEl.method = checkout.method
  formEl.submit()
}

export function addressStringFromPlace(place: GooglePlace) {
  const {
    street_number,
    route,
    locality,
    administrative_area_level_2,
    country,
    postal_code
  } = place

  /*
  var lstSpazio = [];
  if(locality) lstSpazio.push(locality);
  // if(administrative_area_level_2) lstSpazio.push(administrative_area_level_2);
  // if(country) lstSpazio.push(country);
  if(postal_code) lstSpazio.push(postal_code);
  let strSpazio = lstSpazio.join(' ');
  */

  var lstVirgola = [];
  if (route) lstVirgola.push(route);
  if (street_number) lstVirgola.push(street_number)
  if (locality) lstVirgola.push(locality);
  if (postal_code) lstVirgola.push(postal_code);
  // if(strSpazio) lstVirgola.push(strSpazio);
  let strVirgola = lstVirgola.join(', ');

  return strVirgola;
}

export function placeFromAddressObject(address: CustomerAddress): GooglePlace {
  return {
    street_number: address.streetNumber,
    route: address.route || '',
    locality: address.city,
    administrative_area_level_2: address.city,
    country: address.country,
    postal_code: address.postalCode
  }
}

export function checkoutPaymentStarted(checkout: Checkout) {
  return ['PAYMENT_STARTED', 'PAYMENT_SUCCESS'].includes(checkout.status)
}

export function isWishope() {
  const shopIdList = [1002476, 1009882, 1009904, 1009903, 1009902];

  const { pathname } = window.location;
  const parts = pathname ? pathname.split('/') : [];
  if (parts.length >= 4) {
    return shopIdList.indexOf(Number(parts[3])) >= 0;
  }
  return false;
}

export function getDescriptionByCurrentVas(): string {

  const { pathname } = window.location;
  const parts = pathname ? pathname.split('/') : [];
  const vasId = String(parts[3])

  if (vasId == '1002476') {
    return `L'associazione è impegnata dal 1898 ad assicurare gratuitamente cibo <span style="font-weight:bold;color:#00654C">a chiunque ne abbia bisogno</span>. Grazie a un team di volontari dedicati, l'associazione coordinerà e organizzerà la consegna dei generi alimentari acquistati <span style="font-weight:bold;color:#00654C">presso le sue sedi</span> e <span style="font-weight:bold;color:#00654C">direttamente presso le abitazioni</span>  di coloro che, a causa di disabilità, hanno difficoltà a recarsi autonomamente a ritirare le derrate alimentari, <span style="font-weight:bold;color:#00654C">migliorando così la loro qualità di vita</span> e promuovendo l'inclusione sociale.`
  }
  else if (vasId == '1009882') {
    return `<span style="font-weight:bold;color:#00654C">Portofranco</span> è un'organizzazione di volontariato che aiuta a studiare ragazze e ragazzi delle scuole medie superiori e che riunisce <span style="font-weight:bold;color:#00654C">40 centri presenti su tutto il territorio nazionale.</span> La responsabilizzazione dei ragazzi, la cura uno a uno, la preoccupazione educativa che anima tutti i volontari, sono alla base di un metodo che si è rivelato da subito efficace e premiato dai risultati. Portofranco è oggi un punto di riferimento per la <span style="font-weight:bold;color:#00654C">prevenzione della dispersione scolastica</span> e del disagio giovanile, luogo di speranza e di inclusione e distribuirà gli zaini presso tutte le sue sedi.`
  }
  else if (vasId == '1009902') {
    return `<span style="font-weight:bold;color:#00654C">CRI4Kids</span> è il progetto della Croce Rossa di Milano per il contrasto alla povertà infantile, che in Italia colpisce <span style="font-weight:bold;color:#00654C">oltre 1 milione e 200mila minori</span>. Grazie al supporto dei volontari, le famiglie indigenti con figli piccoli riceveranno beni di prima necessità specifici per l'infanzia. Un regalo che renderà speciale il loro futuro!`
  }
  else if (vasId == '1009903') {
    return `"La nostra missione umanitaria: aiutare chiunque abbia bisogno, sulla strada, a cominciare dai senza fissa dimora. Ogni sera, in ogni città in cui operiamo, andiamo per strada a portare loro coperte, vestiti, sacchi a pelo, cibo, bevande". I volontari di <span style="font-weight:bold;color:#00654C">City Angels</span>, riconoscibili dal basco blu, simbolo delle forze Onu portatrici di pace, e dalla giubba rossa, colore dell’emergenza, distribuiranno i beni acquistati a tutte le persone che aiutano ogni giorno.`
  }
  else if (vasId == '1009904') {
    return ` L'associazione è impegnata dal 1898 ad assicurare gratuitamente cibo <span style="font-weight:bold;color:#00654C">a chiunque ne abbia bisogno</span>. Grazie a un team di volontari dedicati, l'associazione coordinerà e organizzerà la consegna dei generi alimentari acquistati, <span style="font-weight:bold;color:#00654C">presso le sue sedi e direttamente presso le abitazioni</span> di coloro che, a causa di disabilità, hanno difficoltà a recarsi autonomamente a ritirare le derrate alimentari, <span style="font-weight:bold;color:#00654C">migliorando così la loro qualità di vita</span> e promuovendo l'inclusione sociale.`
  }

  return '';

  // return descriptions[vasId];
}